import { type SyntheticEvent, useCallback, useState } from 'react'
import { Time } from '../typings'

export function useListState(value: Time) {
  const [open, setOpen] = useState(false)

  const onOpen = useCallback(
    (e: SyntheticEvent) => {
      const ignore = e.type === 'mousedown' || e.type === 'change'

      if (value === null || !ignore) {
        setOpen(true)
      }
    },
    [value],
  )

  const onClose = useCallback(() => setOpen(false), [])

  return {
    open,
    onOpen,
    onClose,
  }
}
